import SiteNavbar from '@/components/feature/SiteNavbar';
import SiteFooter from '@/components/feature/SiteFooter';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import ProductsSection from './components/ProductsSection';
import StackSection from './components/StackSection';
import ContactSection from './components/ContactSection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#0c0c0c]">
      <SiteNavbar sectionAware={true} />
      <HeroSection />
      <ProductsSection />
      <StackSection />
      <ContactSection />
      <SiteFooter />
      <ScrollToTop />
    </div>
  );
}

